import {OverlayOptions} from "./Overlay.js";
import {tools} from "../tools.js";
import LazyBackground from "../lazy/LazyBackground.js";

class Handler {
    constructor(anchor) {
        this.anchor = anchor;
    }

    handleClick(e) {
        throw 'Implement this in a subclass';
    }
}

class DomEltTarget extends Handler {
    constructor(anchor) {
        super(anchor);
        if (anchor.dataset.target) {
            this.target = document.querySelector(anchor.dataset.target);
        }
    }
}

class OverlayHandler extends DomEltTarget {

    constructor(anchor) {
        super(anchor);
        if (anchor.dataset.url) {
            this.url = anchor.dataset.url;
        }
    }

    handleClick(e) {

        console.log("CCLIK")
        if (this.target) {
            this.createOpenAndDisplayOverlay();
            console.log(this.target)
        }
    }
    createOpenAndDisplayOverlay() {
        new OverlayOptions()
            .setElement(this.target)
            .display()
    }

}

class AjaxOverlayHandler extends DomEltTarget {

    constructor(anchor) {
        super(anchor);
        this.href = anchor.dataset.href;
        this.target = anchor.dataset.target;
    }

    handleClick(e) {
        if (this.href) {
            tools.ajxGet(this.href, {
                fallback: resp => {
                    const targetElt = resp.querySelector(this.target);
                    if (targetElt) {
                        this.targetElt = targetElt;
                        new OverlayOptions()
                            .setElement(this.targetElt)
                            .display();
                    }
                }
            })

        }
    }
}

class ScrollToHandler extends DomEltTarget {
    constructor(anchor) {
        super(anchor);
    }

    handleClick(e) {
        if (this.target) {
            tools.scrollToElt(window, this.target);
            window.location.hash = this.anchor.dataset.target;
        }
    }
}

export default class AnchorWC extends HTMLAnchorElement {
    constructor() {
        super();
        this.handler;
        this.defineHandler();
        this.clickListener();
    }

    defineHandler() {
        if (this.dataset.handler) {
            switch (this.dataset.handler) {
                case 'overlay':
                    this.handler = new OverlayHandler(this);
                    break;
                case 'ajaxOverlay':
                    this.handler = new AjaxOverlayHandler(this);
                    break;
                case 'scrollTo':
                    this.handler = new ScrollToHandler(this);
                    break;
            }
        }
    }


    clickListener() {
        if (this.handler) {
            this.addEventListener('click', e => {
                e.preventDefault();
                this.handler.handleClick(e);
            })
        }
    }
}
